import BaseViewModel from "./BaseViewModel";

class TitleControlViewModel extends BaseViewModel {

	Validate = () => true;
	getSimpleFormatXmlTagName = () => 'Title';

};

export default TitleControlViewModel;
